import { useCallback } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { Image } from "../../../common/interfaces/ProductDetailsDataInterface";
import {
    setActive,
    setLightboxSlices,
} from "../../../modals/productGalleryModal/productGalleryModalSlice";

export const useProductDetailGallery = (): ((images: Image[]) => void) => {
    const dispatch = useAppDispatch();

    return useCallback(
        (images: Image[]) => {
            dispatch(setLightboxSlices(images));
            dispatch(setActive(true));
        },
        [dispatch],
    );
};
